import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';

import { HffCommonUiUsheruLogoModule } from '@usheru-hff/hff-common/ui-usheru-logo';
import {
  ShowtimeStreamingSubscribeComponent,
  FormSubscriptionComponent
} from '@usheru-hff/movie-detail/feature-subscribe';
import { LocationSelectorComponent } from '@usheru-hff/shared/feature-location-selector';
import { LoadingIndicatorComponent } from '@usheru-hff/shared/ui-loading-indicator';
import { SharedUiModalMapModule } from '@usheru-hff/shared/ui-modal-map';
import { SwiperDirective } from '@usheru-hff/shared/ui-swiper';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

import { RtPipe } from '@usheru-hff/ui/pipes';

import { DatesCarouselComponent } from './dates-carousel/dates-carousel.component';
import { LoadMoreCinemasComponent } from './load-more-cinemas.component';
import { ShowtimesStoreService } from './shared/showtimes.service';
import { PerformanceComponent as PerformanceNewComponent } from './showtime-streaming-in-cinemas/performance/performance.component';
import { PerformanceHeaderComponent } from './showtime-streaming-in-cinemas/performances-header/performance-header.component';
import {
  ShowtimeStreamingInCinemasComponent,
  ShowtimeStreamingInCinemasComponent as ShowtimeStreamingInCinemasNewComponent
} from './showtime-streaming-in-cinemas/showtime-streaming-in-cinemas.component';
import { ShowtimeStreamingMapComponent } from './showtime-streaming-in-cinemas/showtime-streaming-map/showtime-streaming-map.component';
import { UiAttributeComponent } from './ui-attribute/ui-attribute.component';
import { UiDateComponent } from './ui-date/ui-date.component';
import { UiHourComponent } from './ui-hour/ui-hour.component';
import { UshShowtimeDatesComponent } from './ush-showtime-dates/ush-showtime-dates.component';

@NgModule({
  imports: [
    LoadMoreCinemasComponent,
    CommonModule,
    RouterModule.forChild([]),
    AccordionModule,
    LocationSelectorComponent,
    ButtonModule,
    LoadingIndicatorComponent,

    SharedUtilsImageModule,
    SharedUiModalMapModule,
    SharedUtilsModule,
    HffCommonUiUsheruLogoModule,
    FontAwesomeModule,
    SwiperDirective,
    SkeletonModule,
    TooltipModule,
    ShowtimeStreamingSubscribeComponent,
    FormSubscriptionComponent,
    RtPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    PerformanceNewComponent,
    ShowtimeStreamingInCinemasComponent,
    UshShowtimeDatesComponent,
    DatesCarouselComponent,
    UiDateComponent,
    UiAttributeComponent,
    UiHourComponent,
    ShowtimeStreamingMapComponent,
    PerformanceHeaderComponent
  ],
  providers: [ShowtimesStoreService],
  exports: [ShowtimeStreamingInCinemasComponent, ShowtimeStreamingInCinemasNewComponent]
})
export class MovieDetailFeatureShowtimesModule {}
